export const shallowChanged = <T extends Record<string, any>>(values: T, initialValues: T) =>
  (Object.keys(values) as Array<keyof T>).reduce<Partial<T>>((result, key) => {
    if (values[key] === initialValues[key]) return result
    result[key] = values[key]
    return result
  }, {})
